import gql from 'graphql-tag';

const allowPendingOfferMutation = gql`
  mutation allowPendingOffer($input: AllowPendingOfferInput!) {
    allowPendingOffer(input: $input) {
      success
      errors
    }
  }
`;

export default allowPendingOfferMutation;
